import Image from "next/image";
import withWindowDimensions from "../shared/withWindowDimensions";

const ProductCard = ({
  productData,
  primaryCtaText,
  primaryCtaHandler,
  secondaryCtaText,
  secondaryCtaHandler,
  isMobileSized,
}) => {
  return (
    <div className="bg-white rounded-12 flex flex-wrap items-center shadow-2">
      <div className="w-full lg:w-auto">
        <Image
          src={productData.image}
          alt={productData.title}
          height={
            isMobileSized
              ? productData?.mobileImageHeight
              : productData?.webImageHeight
          }
          width={
            isMobileSized
              ? productData?.mobileImageWidth
              : productData?.webImageWidth
          }
          className="max-w-full h-auto mx-auto lg:mx-0"
        />
      </div>
      <div className="w-full lg:w-4/12 px-4 lg:px-0 lg:pl-12">
        <p className="text-lg md:text-2dot5xl text-blue-950 font-bold pb-4 lg:pb-8 text-center lg:text-left pt-8 lg:pt-0 leading-9 whitespace-nowrap">
          {productData.title}
        </p>
        <div className="flex justify-center">
          <ul className="list-image-[url('/advance-website/assets/images/new-landing-page/tick.svg')] ml-10 md:ml-14">
            {productData?.features?.map((feature, index) => (
              <li className="text-blue-950 text-sm md:text-l pb-3" key={index}>
                {feature}
              </li>
            ))}
          </ul>
        </div>
        <div className="pt-4 pb-4 md:pb-0 md:pt-10">
          <div className="flex justify-center md:justify-start">
            <button
              onClick={primaryCtaHandler}
              className="w-full bg-primary hover:bg-primaryLighter text-white text-center text-l py-4 rounded-sm font-bold"
            >
              {primaryCtaText}
            </button>
          </div>
          <div className="flex justify-center pt-2 pb-6 lg:pb-0 lg:pt-8">
            <button
              onClick={secondaryCtaHandler}
              className="text-primary text-center underline"
            >
              {secondaryCtaText}
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default withWindowDimensions(ProductCard);
